import * as React from "react";
import { FixedCommentSetFormModel } from "../types";
import { Required } from "../../../forms/validation/Required";
import { Dropdown } from "../../../forms/informedv2/Dropdown";
import { nameof } from "ts-simple-nameof";
import { Option } from "informed";
import FixedCommentEntries from "./FixedCommentEntries";
import { UseOrderedCommentsState } from "./UserOrderedComments";
import { useReferenceContextProvider } from "../../../Core/ReferenceContextProvider";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";

interface CreateFixedCommentFormProps extends Omit<UseOrderedCommentsState, "reset">{
    editMode: boolean;
    initialState: FixedCommentSetFormModel
}

const FixedCommentsFormBody = ({ editMode, initialState, ...props }: CreateFixedCommentFormProps): JSX.Element => {

    const { sessionTypes } = useCurrentStudyConfigurationContext();
    const { fixedCommentSetEntityTypes, fixedCommentSetTypes } = useReferenceContextProvider();

    return (<>
        <div className="row">
            <div className="form-group col-md-4 col-sm-4 col-xs-12">
                <label htmlFor="SetType">Comment Set Type</label>
                <Dropdown disabled={editMode || !fixedCommentSetTypes.length} id="SetType" field={nameof<FixedCommentSetFormModel>(f => f.SetType)} validate={Required}>
                    <Option
                        key={"OptionSetTypeBlank"}
                        value={[]}
                    />
                    {fixedCommentSetTypes.map(ast => (
                        <Option
                            key={`Option${ast.id}`}
                            value={ast.id}
                        >
                            {ast.name}
                        </Option>
                    ))}
                </Dropdown>
            </div>
            <div className="form-group col-md-4 col-sm-4 col-xs-12">
                <label htmlFor="SessionType">Session Type</label>
                <Dropdown disabled={!sessionTypes.length || editMode} id="SessionType" field={nameof<FixedCommentSetFormModel>(f => f.SessionType)} validate={Required}>
                    <Option
                        key={"OptionSessionTypeBlank"}
                        value={[]}
                    />
                    {sessionTypes.map(ast => (
                        <Option
                            key={`Option${ast.Id}`}
                            value={ast.Id}
                        >
                            {ast.Name}
                        </Option>
                    ))}
                </Dropdown>
            </div>
            <div className="form-group col-md-4 col-sm-4 col-xs-12">
                <label htmlFor="EntityType">Entity Type</label>
                <Dropdown disabled={!fixedCommentSetEntityTypes.length || editMode} id="EntityType" field={nameof<FixedCommentSetFormModel>(f => f.EntityType)} validate={Required}>
                    <Option 
                        key={"OptionEntityTypeBlank"}
                        value={[]}
                    />
                    {fixedCommentSetEntityTypes.map(ast => (
                        <Option
                            key={`Option${ast.id}`}
                            value={ast.id}
                        >
                            {ast.name}
                        </Option>
                    ))}
                </Dropdown>
            </div>
        </div>
        <FixedCommentEntries editMode={editMode} initialEntries={initialState?.Comments} {...props}/>
    </>);
};


export default FixedCommentsFormBody;
